import React from "react";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { IService, IServiceCategory } from "../../../store/userService/types";
import { ITUService } from "../../../store/dashboardService/types";
import ServiceItem from "./ServiceItem";
import UpgradeService from "./UpgradeService";

const ServiceCategory = (props: { serviceCategory: IServiceCategory, tuServices: ITUService[] }) => {
    const categoryLogos = new Map([
        ["Monitor", "shield-alt"],
        ["Alert", "bell"],
        ["Credit", "tachometer-alt"],
        ["Control", "hand-paper"],
        ["Recover", "history"],
        ["Moniteur", "shield-alt"],
        ["Alerte", "bell"],
        ["Crédit", "tachometer-alt"],
        ["Contrôle", "hand-paper"],
        ["Récupérer", "history"],
    ]);

    const categoryName = props.serviceCategory.categoryName ? props.serviceCategory.categoryName : "";
    const categoryLogo = categoryLogos.get(categoryName);

    if (props.serviceCategory.isUpgradable) {
        return <UpgradeService categoryName={categoryName} upgradableText={props.serviceCategory.upgradableText ? props.serviceCategory.upgradableText : ""} />;
    }

    if (!props.serviceCategory || !props.serviceCategory.services || props.serviceCategory.services.length <= 0) {
        return <React.Fragment></React.Fragment>;
    }

    const isTUService = (service: IService) => {
        // This a group of services considered as TU Services
        if (service.serviceCode === "SVC-PUBMON") {
            return true;
        }
        const found = props.tuServices.find(tuService => {
            return tuService.code && tuService.code === service.serviceCode;
        });
        return found ? true : false;
    }

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName={categoryLogo ? categoryLogo : ""} />
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{categoryName}</h2>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    <div role="grid" className="data-grid " id="my-account-info-grid" aria-hidden="false">
                        {props.serviceCategory.services &&
                            props.serviceCategory.services.map((service, index) => {
                                return (
                                    <React.Fragment key={`${props.serviceCategory.categoryName}-${index}-${service.displayName}`}>
                                        <ServiceItem key={`${props.serviceCategory.categoryName}-${index}-${service.displayName}`} service={service} isTUService={isTUService(service)} id={`${service.category}-${index}`} />
                                    </React.Fragment>
                                );
                            })}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ServiceCategory;
